import { BoxGeometry, Group, Mesh, SphereGeometry, TorusGeometry } from 'three';
import { RescueTool } from './RescueTool';

export class InflatableBoat extends RescueTool {
  inflation = 0.05;
  private readonly hull = new Group();

  constructor() {
    super('inflatableBoat');
    const tubeMaterial = this.standardMaterial(0x5d63d8);
    for (const x of [-1.3, 1.3]) {
      const tube = new Mesh(new TorusGeometry(1.7, 0.38, 8, 18, Math.PI), tubeMaterial);
      tube.rotation.set(Math.PI / 2, 0, x < 0 ? Math.PI / 2 : -Math.PI / 2);
      tube.position.x = x;
      tube.castShadow = true;
      this.hull.add(tube);
    }
    const floor = new Mesh(new BoxGeometry(3.6, 0.2, 2.3), this.standardMaterial(0x454db2));
    this.hull.add(floor);
    const valve = new Mesh(new SphereGeometry(0.16, 8, 6), this.standardMaterial(0xffc83d));
    valve.position.set(1.8, 0.35, 0.8);
    this.hull.add(valve);
    this.group.add(this.hull);
    this.applyInflation();
  }

  inflate(amount: number): void {
    this.inflation = Math.min(1, this.inflation + amount);
    this.applyInflation();
  }

  private applyInflation(): void {
    const scale = 0.18 + this.inflation * 0.82;
    this.hull.scale.set(scale, scale, scale);
  }

  steer(direction: number, delta: number, riverSpeed: number): void {
    this.group.position.z += direction * delta * 5.2;
    this.group.position.x -= delta * (3.4 + riverSpeed * 0.35);
    this.group.rotation.y = -direction * 0.25;
    this.group.position.y = 0.65 + Math.sin(performance.now() * 0.004) * 0.08;
  }
}
